import { maskIdNo, maskPhone, maskName } from '@/filters';

/**
 * 脱敏自定义指令
 * 用法：
 * v-desensitize:idNo="value" - 身份证脱敏
 * v-desensitize:phone="value" - 手机号脱敏
 * v-desensitize:name="value" - 姓名脱敏
 */
export default {
    bind(el, binding, vnode) {
        const value = binding.value;
        const type = binding.arg || 'idNo'; // 默认身份证
        
        // 存储原始值
        el._originalValue = value;
        el._isMasked = true; // 默认脱敏
        
        // 根据类型选择脱敏方法
        let maskedValue = getMaskedValue(value, type);
        
        el.textContent = maskedValue;
        
        // 添加点击事件和样式
        el.style.cursor = 'pointer';
        el.title = '点击切换显示/隐藏';
        el.classList.add('desensitize-text');
        
        el._clickHandler = () => {
            el._isMasked = !el._isMasked;
            updateDisplay(el, type);
        };
        
        el.addEventListener('click', el._clickHandler);
    },
    
    componentUpdated(el, binding) {
        // 当值变化时更新
        const value = binding.value;
        const type = binding.arg || 'idNo';
        
        el._originalValue = value;
        updateDisplay(el, type);
    },
    
    unbind(el) {
        // 清理事件监听
        if (el._clickHandler) {
            el.removeEventListener('click', el._clickHandler);
        }
    }
};

/**
 * 根据类型获取脱敏后的值
 */
function getMaskedValue(value, type) {
    if (!value) return value;
    
    switch(type) {
        case 'idNo':
            return maskIdNo(value);
        case 'phone':
            return maskPhone(value);
        case 'name':
            return maskName(value);
        default:
            return maskIdNo(value);
    }
}

/**
 * 更新显示内容
 */
function updateDisplay(el, type) {
    if (el._isMasked) {
        el.textContent = getMaskedValue(el._originalValue, type);
    } else {
        el.textContent = el._originalValue;
    }
}



// WEBPACK FOOTER //
// ./src/directives/desensitize.js